import * as React from "react";
import { useSelector } from "react-redux";

import { EMPTY_OBJECT } from "@/react/empty";
import { pbxIdSelector } from "@/react/features/customer/customerSlice";

import pbxMapToOptions from "./pbxMapToOptions";

/**
 * This hook controls a react-select-type drop-down for PBX selection based on
 * the current customer data.
 *
 * Customer data may contain an attribute called preselectedPbxId which
 * contains the ID of the PBX that the user selected via {@link ResultCard.jsx}.
 *
 * @param stagedCustomer - (staged) customer data, see {@link ResultCard.jsx}.
 */
const useManagedPbxSelection = (stagedCustomer) => {
  const pbxMap = stagedCustomer?.pbxMap ?? EMPTY_OBJECT;
  const pbxOptions = React.useMemo(() => pbxMapToOptions(pbxMap), [pbxMap]);
  const committedPbxId = useSelector(pbxIdSelector);
  const stagedPbxId = stagedCustomer?.preselectedPbxId;
  const [selectedPbx, setSelectedPbx] = React.useState();
  const findPbx = React.useCallback(
    (pbxId) => {
      return pbxOptions.find((item) => item.value === pbxId);
    },
    [pbxOptions]
  );

  React.useEffect(() => {
    const pbxId = stagedPbxId ?? committedPbxId ?? pbxOptions?.[0];
    const pbx = findPbx(pbxId);
    setSelectedPbx(pbx ?? null);
  }, [committedPbxId, stagedPbxId, findPbx, setSelectedPbx]);

  return [pbxOptions, selectedPbx];
};

export default useManagedPbxSelection;
